import { apiClient } from '@/utils/axios.ts'

import type { FunnelCheck, FunnelCheckCreate, FunnelCheckEdit } from '../types'

const getFunnelMonitoringBaseUrl = (creatorId: number) =>
  `/funnel-check/${creatorId}`

const getFunnelList = async (creatorId: number) => {
  const response = await apiClient.get<Array<FunnelCheck>>(
    getFunnelMonitoringBaseUrl(creatorId),
  )

  return response.data
}

const deleteFunnelCheck = async (creatorId: number, checkId: number) => {
  const response = await apiClient.delete(
    `${getFunnelMonitoringBaseUrl(creatorId)}/${checkId}`,
  )

  return response.data
}

const editFunnelCheck = async (
  creatorId: number,
  checkId: number,
  body: FunnelCheckEdit,
) => {
  const response = await apiClient.put<FunnelCheck>(
    `${getFunnelMonitoringBaseUrl(creatorId)}/${checkId}`,
    body,
  )

  return response.data
}

const addFunnelCheck = async (creatorId: number, body: FunnelCheckCreate) => {
  const response = await apiClient.post<FunnelCheck>(
    `${getFunnelMonitoringBaseUrl(creatorId)}`,
    body,
  )

  return response.data
}

const manualFunnelCheck = async (creatorId: number, checkId: number) => {
  const response = await apiClient.get<FunnelCheck>(
    `${getFunnelMonitoringBaseUrl(creatorId)}/${checkId}/manual-check`,
  )

  return response.data
}

const getFunnelCheckDetails = async (creatorId: number, checkId: number) => {
  const response = await apiClient.get<FunnelCheck>(
    `${getFunnelMonitoringBaseUrl(creatorId)}/${checkId}`,
  )

  return response.data
}

export const funnelMonitoringService = {
  getFunnelList,
  deleteFunnelCheck,
  editFunnelCheck,
  addFunnelCheck,
  getFunnelCheckDetails,
  manualFunnelCheck,
}
